import { useNavigate } from 'react-router-dom'

interface AdminBadgeProps {
  className?: string
}

export default function AdminBadge({ className = '' }: AdminBadgeProps) {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate('/admin/dashboard')}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer hover:opacity-80 ${className}`}
      style={{
        backgroundColor: 'var(--brand-primary)',
        color: 'white'
      }}
      title="Return to Admin Dashboard"
    >
      <svg className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
      </svg>
      Admin
    </button>
  )
}